import { useEffect } from 'react';
import type { DataSnapshot } from '@framework/repository';
import { RefBuilder } from '@framework/repository';
import type { UserId } from 'balus-common';
import { RTDBPath } from 'balus-common';
import { trpcClient } from '@framework/trpcClient';

type Props = {
  currentUserId: UserId | null;
};

export const CheckIp: React.FC<Props> = ({ currentUserId }: Props) => {
  useEffect(() => {
    const ref = RefBuilder.ref(RTDBPath.Firebase.connectedPath());
    const callback = async (snapshot: DataSnapshot) => {
      const isOnline = !!snapshot.val();

      if (isOnline && currentUserId) {
        trpcClient.user.checkIp.mutate().then();
      }
    };

    ref.on('value', callback);
    return () => {
      ref.off('value', callback);
    };
  }, [currentUserId]);

  return <></>;
};
